var React = require('react');

function ContentMegaphone (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"content-megaphone"),React.createElement("g",{"key":1},React.createElement("g",null,[React.createElement("path",{"d":"M5.7,23.76l7.87,1.88a.57.57,0,0,0,0,.26C15.24,37,29.51,40.24,36,31.17a.3.3,0,0,0,0-.15L49.7,34.29v-33L5.7,11.78ZM17.59,26.6,32,30.06A8.58,8.58,0,0,1,17.59,26.6Z","key":0}),React.createElement("path",{"d":"M55.13,0l-3.6.86v33.8l3.6.86a.5.5,0,0,0,.61-.48V.5A.5.5,0,0,0,55.13,0Z","key":1}),React.createElement("path",{"d":"M0,11.44V24.1a.49.49,0,0,0,.61.48l3.45-.82v-12L.61,11A.49.49,0,0,0,0,11.44Z","key":2})]))]);
}

ContentMegaphone.defaultProps = {"viewBox":"0 0 55.74 36.44"};

module.exports = ContentMegaphone;

ContentMegaphone.default = ContentMegaphone;
